// Mirror of server/utils/permissions.js. The server is what actually enforces access; this decides
// what the UI offers, so the two must agree. Admins pass every check.
export const ROLES = {
  STANDARD: 'standard',
  CMS: 'cms',
  SPECIAL: 'special',
};

// Roles stored before the split, and anything unrecognised, map onto the new ones
const LEGACY_ROLES = {
  jtpdevconsole: ROLES.CMS,
  standard: ROLES.STANDARD,
  'secret santa player': ROLES.STANDARD,
};

export const normalizeRole = (role) => {
  const value = String(role || '').trim().toLowerCase();
  if (Object.values(ROLES).includes(value)) return value;
  return LEGACY_ROLES[value] || ROLES.STANDARD;
};

// `special` is standard plus whatever is still in testing
export const FEATURES = {
  dashboard: [ROLES.STANDARD, ROLES.SPECIAL],
  notes: [ROLES.STANDARD, ROLES.SPECIAL],
  shortcuts: [ROLES.STANDARD, ROLES.SPECIAL],
  reminders: [ROLES.STANDARD, ROLES.SPECIAL],
  grocery: [ROLES.STANDARD, ROLES.SPECIAL],
  checklist: [ROLES.SPECIAL],
  console: [ROLES.CMS],
};

export const can = (userInfo, feature) => {
  if (!userInfo) return false;
  if (userInfo.isAdmin) return true;

  const allowed = FEATURES[feature];
  return Array.isArray(allowed) && allowed.includes(normalizeRole(userInfo.role));
};

// Where a role lands after logging in, and where a blocked page sends them: CMS users only have
// the console, so they never see the dashboard
export const homeFor = (userInfo) => (
  !userInfo?.isAdmin && normalizeRole(userInfo?.role) === ROLES.CMS ? '/console' : '/dashboard'
);
